import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const addAccountantRefereeMutation = gql`
  mutation addAccountantReferee(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $email: String!
    $name: String!
    $phone: String!
    $incomeId: String
  ) {
    addAccountantReferee(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      email: $email
      name: $name
      phone: $phone
      incomeId: $incomeId
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  email: string
  name: string
  phone: string
  incomeId: string
}

export type AddAccountantRefereeData = {
  addAccountantReferee: string | unknown
}

export const useAddAccountantRefereeMutation: WrappedMutation<
  AddAccountantRefereeData,
  MutationVars
> = () =>
  useMutation<AddAccountantRefereeData, MutationVars>(addAccountantRefereeMutation, {
    client: agentClient,
  })
